import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
class ScrollReveal {
  constructor(options){
    this.options = options;
  }

  reveal(el, options, duration){
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire( el, function(){
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options,args);
      anime(args);
    }, {
      offset: window.innerHeight - 100
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 6000,
          // animateIn: 'fadeIn',
          animateOut: 'fadeOut',
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          // navText: ['<img src="/wp-content/themes/shakai.kanto-gakuin-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/shakai.kanto-gakuin-html/dist/assets/images/icon-slider-next.svg" />'],
        });
        var dotItem = $('.owl-dots button');
        var dotNum = 0;
        var win = $(window).innerWidth();
        for (var i = 0; dotItem.length > i; i++) {
          dotNum++;
          dotItem.find('span').eq(i).text("0" + dotNum);

          if (win < 950) {
            dotItem.find('span').eq(i).text("0" + (dotNum - 3));
          }
        }
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/shakai.kanto-gakuin-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/shakai.kanto-gakuin-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });

      owls.imagesLoaded(function () {
        if ($('.js-card-teacher-slider .c-card__link').length <= 3){
          $('.js-card-teacher-slider').removeClass('owl-carousel');
          return false;
        }
        $('.js-card-teacher-slider').owlCarousel({
          margin: 0,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          stagePadding: 0,
          navText: ['<img src="/wp-content/themes/shakai.kanto-gakuin-html/dist/assets/images/icon-slider-fontawesome-left.png" />', '<img src="/wp-content/themes/shakai.kanto-gakuin-html/dist/assets/images/icon-slider-fontawesome-right.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              autoWidth: true,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }
    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '8';

      sr.reveal(".c-main-visual", {
        duration: 1400,
        opacity: 1,
        //translateY: -baseDistance,
        delay: 900,
      }, 100);

      sr.reveal(".c-block-design__box-bg,.c-block-design__text-bg",{
        opacity: 1,
        duration: 10000,
        delay: 0,
        easing: baseEasing
      });

      domEach(".c-card-sm__block", function(key, item){

        sr.reveal(item,{
          scale: {
            value: [0.9,1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100*key,
          translateY: [-baseDistance,0],
          easing: baseEasing
        } );
      });
    }

    // modaal
    function modaal() {
      // ====================
      // <HTML>
      // <a href="path/to/image.jpg" class="js-modal-image" data-modaal-desc="My Description">Show</a>
      // or
      // <button data-modaal-content-source="path/to/image.jpg" class="js-modal-image">Show</button>
      // ====================

      $('.js-modal-image').modaal({
        type: 'image'
      });
    }

    //モーダル
    function originmodal() {

      //モーダルを開いた時のスクロール位置を保持
      var scrollPosition;
      //iOS（iPadOSを含む）かどうかのUA判定
      var ua = window.navigator.userAgent.toLowerCase();
      var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

      //bodyのスクロール固定
      function bodyFixedOn() {
        if(isiOS){
          // iOSの場合
          scrollPosition = $(window).scrollTop();
          $('body').css('position', 'fixed');
          $('body').css('top', '-' + scrollPosition + 'px');
        }else {
          // それ以外

          $('body').css('overflow', 'hidden');
        }
      }

      //bodyのスクロール固定を解除
      function bodyFixedOff() {
        if(isiOS){
          // iOSの場合
          $('body').css('position', '');
          $('body').css('top', '');
          $(window).scrollTop(scrollPosition);
        }else {
          // それ以外
          $('body').css('overflow', '');
        }
      }

      $('.c-card__block').on('click', function (e) {
        const $item = $(this);
        const modalId = $item.data("teacher-target");
        const $modal = $('.c-card__modal[data-teacher-content="' +  modalId + '"]');

        e.preventDefault();


        if ($modal.hasClass("is-active")) {
          $modal.removeClass('is-active');
          $modal.addClass("is-hidden");
          bodyFixedOff();
          setTimeout(() => {
            $modal.removeClass("is-hidden");
          }, 500);
        } else {
          $modal.addClass('is-active');
          bodyFixedOn();

        }
      });


      $('.c-card__modal-close, .c-card__modal-overlay').on('click', function (e) {
        const $modal = $(this).parents('.c-card__modal');
        $modal.removeClass('is-active');
        $modal.addClass("is-hidden");
        bodyFixedOff();
        setTimeout(() => {
          $modal.removeClass("is-hidden");
        }, 500);
      });


    }


    // コピーライトの年数自動出力
    function autoWriteYear() {
      $('.js-current-year').text(new Date().getFullYear());
    }

    // --------------- アニメーショントリガー（メインビジュアル,ページヘッダー）
    function animationTrigger(el) {
      $(el).addClass('is-animating');
    }

    function animationOrigin(){
      $(window).scroll(function (){
        $(".c-block-about__descriptions").each(function(){
          var hit		= $(this).offset().top;
          var scroll	= $(window).scrollTop();
          var wHeight	= $(window).height();

          if (scroll > hit - wHeight + wHeight/5){
            $(this).addClass("is-animating");
          }
        });
      });
    }


    $(function () {
      menuSlide();
      owlCarousel();
      modaal();
      originmodal();
      reveal();
      autoWriteYear();
      $(window).on('load', function () {
        animationTrigger('.c-main-visual__slider');
        animationTrigger('.c-main-visual__inner');
      });
      animationTrigger('.l-page-header__inner');
      animationOrigin();
    });
  }
}

window.GApp = new App();
